import Details from "../Conponents/Details";

const MainRoutes = [
  {
    path: "/",
    name: "Admin Dashboard",
    element: <Details />,
  },
];

export default MainRoutes;
